var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dot-loader-parent",style:('height:' + _vm.size + '; width:' + _vm.size + ';')},[_c('div',{staticClass:"dot-loader"},_vm._l((_vm.dots),function(dot,i){return _c('div',{key:i,style:('animation-play-state: ' + dot.playState + ';')})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }